import { DUCK_FULLSCREEN_PARAM } from "duck/ui/chat/constants";
import { useSearchParams } from "react-router";

/**
 * This hook reads and sets whether the chat fills the page. The state lives in the
 * URL as `?duckFullscreen=true`, so it ends on its own when the user goes to another
 * page, and survives a reload of the same page.
 */
export const useDuckFullscreen = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const isFullscreen = searchParams.get(DUCK_FULLSCREEN_PARAM) === "true";

  const setFullscreen = (fullscreen: boolean) => {
    if (fullscreen === isFullscreen) {
      return;
    }

    setSearchParams(
      (params) => {
        if (fullscreen) {
          params.set(DUCK_FULLSCREEN_PARAM, "true");
        } else {
          params.delete(DUCK_FULLSCREEN_PARAM);
        }

        return params;
      },
      // Going fullscreen adds a history entry, so Back takes the user out of it.
      { replace: !fullscreen }
    );
  };

  return { isFullscreen, setFullscreen };
};
